import firebase from 'firebase/app'
import 'firebase/messaging'
import { firebaseConfig, firebasePublicVapidKey } from '../../settings'

export default async function initializeFirebase () {
  try {
    firebase.initializeApp(firebaseConfig)
    var messaging = firebase.messaging()
  
    messaging.usePublicVapidKey(firebasePublicVapidKey)
    const token = await messaging.getToken()

    messaging.onMessage((payload) => {
      const notificationOptions = {
        body: payload.data.body
      }
      new Notification(payload.data.title, notificationOptions);
    })

    return token
  } catch (err) {
    console.log('error initializing firebase', err)
  }
}
